import React from 'react';
import { MenuItemWithAnalytics } from '@atlassian/learning-components';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';

import { isConfluenceHubEnabled } from 'src/utils/featureGate';

import { withUrlPrefix, LINKS } from './GlobalAppNavigation';

export const AdoptionMobileMenu: React.FC = () => {
  const confluenceHubEnabled = isConfluenceHubEnabled();

  return (
    <ul css={listStyles}>
      <MenuItemWithAnalytics link={withUrlPrefix(LINKS.ADOPTION_AND_CHANGE_MANAGEMENT_GUIDE)} type="subMenu" />
      <MenuItemWithAnalytics link={withUrlPrefix(LINKS.ROVO_ADOPTION_GUIDE)} type="subMenu" />
      <MenuItemWithAnalytics link={withUrlPrefix(LINKS.JIRA_ADOPTION_GUIDE)} type="subMenu" />
      <MenuItemWithAnalytics link={withUrlPrefix(LINKS.JIRA_CLOUD_ADOPTION_GUIDE)} type="subMenu" />
      {confluenceHubEnabled && (
        <>
          <MenuItemWithAnalytics link={withUrlPrefix(LINKS.CONFLUENCE_ADOPTION_GUIDE)} type="subMenu" />
          <MenuItemWithAnalytics link={withUrlPrefix(LINKS.CONFLUENCE_CLOUD_ADOPTION_GUIDE)} type="subMenu" />
        </>
      )}
    </ul>
  );
};

const listStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: token('space.150'),
  listStyle: 'none',
  margin: 0,
  padding: `${token('space.150')} 0 0 0`,

  '&:hover li': {
    color: token('color.link'),
  },

  li: {
    padding: `${token('space.200')} 0`,
  },
});
